import type { CSSProperties } from 'react'

export const SAMPLE_ROWS = [
  { id: 'ord_4f81', region: 'AU', sku: 'SKU-1042', units: 1240, revenue: 19840, status: 'fulfilled', spark: [12,14,11,18,22,19,24,28,26,31] },
  { id: 'ord_4f82', region: 'US', sku: 'SKU-2188', units: 4820, revenue: 96400, status: 'fulfilled', spark: [22,26,24,28,30,29,33,38,42,46] },
  { id: 'ord_4f83', region: 'DE', sku: 'SKU-0445', units: 318,  revenue: 7950,  status: 'pending',   spark: [4,6,5,7,9,8,10,11,9,12] },
  { id: 'ord_4f84', region: 'JP', sku: 'SKU-2188', units: 902,  revenue: 18040, status: 'fulfilled', spark: [9,8,11,14,12,16,19,18,22,24] },
]

export const cssVar = (k: string): CSSProperties => ({ color: `var(${k})` })
